var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VCombobox',{attrs:{"label":_vm.label,"value":_vm.value,"required":_vm.required,"disabled":_vm.disabled,"hide-details":!_vm.info,"hint":_vm.info,"multiple":"","chips":"","rules":_vm.required ? _vm.isRequired : [],"deletable-chips":""},on:{"change":function($event){return _vm.$emit('change', {val: $event, name: _vm.name})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }